import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpIcon from "@mui/icons-material/Help";

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    Radio,
    RadioGroup,
    Tab,
    Tabs,
    Tooltip,
    Typography,
} from "@mui/material";
import GenericTable from "common/components/GenericTable/GenericTable";
import BubbleChart from "modules/activity/pages/Activities/components/BubbleChart";
import ColumnsChart from "modules/activity/pages/Activities/components/ColumnsChart";
import LineChart from "modules/activity/pages/Activities/components/LineChart";
import MapChartGrapher from "modules/activity/pages/Activities/components/MapChartGrapher";
import PieChart from "modules/activity/pages/Activities/components/PieChart";
import QuestionAnswerForum from "modules/activity/pages/Activities/components/QuestionAnswerForum";
import SocialNetworkChart from "modules/activity/pages/Activities/components/SocialNetworkChart";
import SocialNetworkCommentsChart from "modules/activity/pages/Activities/components/SocialNetworkCommentsChart";
import StaticNetworkBetweennessChart from "modules/activity/pages/Activities/components/StaticNetworkBetweennessChart";
import StaticNetworkChart from "modules/activity/pages/Activities/components/StaticNetworkChart";
import WordCloudChart from "modules/activity/pages/Activities/components/WordCloudChart";
import { useState } from "react";
import { exportMultipleChartsToPdf } from "utils/exportPdf";

const TabResolution = ({
    studentActivityResolutions,
    deliveriesColumns,
    actualGraphResolution,
    handleChangeGraphResolution,
    graphListAvailableResolution,
    graphs,
    dataGraphResolution,
    graphSelectedMapResolution,
    actualResolution,
    getStudentResolutions,
    datasetColumns,
    studentActivity,
    setGraphSelectedMapResolution,
    setDataGraphResolution,
    getStudentActivity,
    activity,
}) => {
    const [valueGraphTab, setValueGraphTab] = useState(0);

    const mapValueGraphTab = {
        normal: 0,
        betweenness: 1,
    };

    const handleChangeGraphTab = (event, newValue) => {
        setValueGraphTab(newValue);
        // handleChangeTabDataSource(dataSourceMap[newValue]);
    };

    return (
        <div>
            <Grid container spacing={5}>
                <Grid item xs={12} lg={6}>
                    <GenericTable
                        height={200}
                        rows={studentActivityResolutions}
                        columns={deliveriesColumns}
                    />
                </Grid>
                <Grid item xs={12} lg={6}>
                    <h3>Observaciones sobre entrega</h3>
                    {actualResolution?.comment}
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} lg={12}>
                    <h3>Seleccionar tipo de gráfico</h3>
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={actualGraphResolution}
                            onChange={handleChangeGraphResolution}
                        >
                            {graphListAvailableResolution.length > 0 &&
                                graphs
                                    .filter((graph) =>
                                        graphListAvailableResolution.includes(graph.value)
                                    )
                                    .sort((a, b) => a.name.localeCompare(b.name))
                                    .map((graph) => (
                                        <FormControlLabel
                                            key={graph.value}
                                            value={graph.value}
                                            control={<Radio />}
                                            label={
                                                <Tooltip
                                                    enterTouchDelay={0}
                                                    leaveTouchDelay={15000}
                                                    disableTouchListener={false}
                                                    title={
                                                        <img
                                                            src={`/img/charts/${graph.name}.png`}
                                                            alt={graph.name}
                                                            width="100%"
                                                            // height="20"
                                                        />
                                                    }
                                                >
                                                    <p>{graph.name}</p>
                                                </Tooltip>
                                            }
                                        />
                                    ))}
                        </RadioGroup>
                    </FormControl>

                    <h4>Observación</h4>
                    {graphSelectedMapResolution[actualGraphResolution]?.comment}

                    {actualGraphResolution === "pie" && (
                        <PieChart
                            data={dataGraphResolution[actualGraphResolution]}
                            xAxis={
                                graphSelectedMapResolution[actualGraphResolution].columns
                                    ?.valuePie[0]
                            }
                        />
                    )}

                    {actualGraphResolution === "column" && (
                        <ColumnsChart
                            data={dataGraphResolution[actualGraphResolution]}
                            xAxis={
                                graphSelectedMapResolution[actualGraphResolution].columns.value[0]
                            }
                            yAxis={
                                graphSelectedMapResolution[actualGraphResolution].columns
                                    .group_by[0]
                            }
                        />
                    )}

                    {actualGraphResolution === "line" && (
                        <LineChart
                            data={dataGraphResolution[actualGraphResolution]}
                            xAxis={
                                graphSelectedMapResolution[actualGraphResolution].columns.value[0]
                            }
                            yAxis={
                                graphSelectedMapResolution[actualGraphResolution].columns
                                    .group_by[0]
                            }
                        />
                    )}

                    {actualGraphResolution === "social_word_frequency" && (
                        <SocialNetworkChart data={dataGraphResolution[actualGraphResolution]} />
                    )}

                    {actualGraphResolution === "social_user_comments" && (
                        <SocialNetworkCommentsChart
                            data={dataGraphResolution[actualGraphResolution]}
                        />
                    )}

                    {actualGraphResolution === "bubble" && (
                        <BubbleChart
                            data={dataGraphResolution[actualGraphResolution]}
                            xAxis={
                                graphSelectedMapResolution[actualGraphResolution].columns.value[0]
                            }
                            yAxis={
                                graphSelectedMapResolution[actualGraphResolution].columns
                                    .group_by[0]
                            }
                        />
                    )}

                    {actualGraphResolution === "map" && (
                        <MapChartGrapher data={dataGraphResolution[actualGraphResolution]} />
                    )}

                    {actualGraphResolution === "word_cloud" && (
                        <div>
                            <Accordion defaultExpanded>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography>Gráfico</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <WordCloudChart
                                        data={dataGraphResolution[actualGraphResolution]}
                                    />
                                </AccordionDetails>
                            </Accordion>

                            <Accordion defaultExpanded>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Typography>
                                        Listado de palabras con su cantidad de apariciones en el
                                        texto
                                    </Typography>
                                    <Tooltip
                                        enterTouchDelay={0}
                                        leaveTouchDelay={15000}
                                        disableTouchListener={false}
                                        title={
                                            <p>
                                                El listado se presenta ordenado por cantidad de
                                                palabras, de mayor cantidad a menor cantidad. El
                                                usuario puede modificar este orden en la lista pero
                                                no se verá reflejado en la nube de palabras.
                                            </p>
                                        }
                                    >
                                        <IconButton size="small">
                                            <HelpIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <GenericTable
                                        rows={Object.entries(
                                            dataGraphResolution[actualGraphResolution] || {}
                                        ).map(([key, value], idx) => ({
                                            id: idx,
                                            term: key,
                                            cant: value,
                                        }))}
                                        columns={[
                                            {
                                                field: "term",
                                                headerName: "Término",
                                                width: 300,
                                            },
                                            {
                                                field: "cant",
                                                headerName: "Cantidad",
                                                width: 300,
                                            },
                                        ]}
                                    />
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    )}

                    {actualGraphResolution === "static_network" && (
                        <>
                            <Tabs
                                sx={{ py: "10px" }}
                                value={
                                    mapValueGraphTab[
                                        graphSelectedMapResolution[actualGraphResolution].metric
                                    ]
                                }
                                onChange={handleChangeGraphTab}
                                aria-label="Tabs for different social network metrics"
                            >
                                <Tab
                                    disabled={
                                        mapValueGraphTab[
                                            graphSelectedMapResolution[actualGraphResolution].metric
                                        ] === 1
                                    }
                                    label={
                                        <p
                                            style={{
                                                alignItems: "center",
                                                display: "flex",
                                            }}
                                        >
                                            Grafo (Grado)
                                            <Tooltip
                                                enterTouchDelay={0}
                                                leaveTouchDelay={15000}
                                                disableTouchListener={false}
                                                title={
                                                    <p>
                                                        El grado de un nodo, en un grafo no
                                                        dirigido, se calcula sumando la cantidad de
                                                        aristas que llegan a él. Por ejemplo: sean
                                                        “a”, “b” y “c” nodos, mientras que “--”
                                                        representa una arista entre dos nodos. Si se
                                                        tienen las siguientes conexiones: a -- b, a
                                                        -- c y b -- a, el grado “()” de cada nodo
                                                        es: a(3), b(2), c(1)
                                                    </p>
                                                }
                                            >
                                                <IconButton size="small">
                                                    <HelpIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </p>
                                    }
                                />
                                <Tab
                                    disabled={
                                        mapValueGraphTab[
                                            graphSelectedMapResolution[actualGraphResolution].metric
                                        ] === 0
                                    }
                                    label={
                                        <p
                                            style={{
                                                alignItems: "center",
                                                display: "flex",
                                            }}
                                        >
                                            Grafo (Intermediación)
                                            <Tooltip
                                                enterTouchDelay={0}
                                                leaveTouchDelay={15000}
                                                disableTouchListener={false}
                                                title={
                                                    <p>
                                                        Mide la frecuencia con la que un nodo
                                                        aparece en los caminos más cortos entre
                                                        todos los pares de nodos de la red. Conocido
                                                        como grado de intermediación (Betweenness
                                                        centrality) pada determinar el tamaño de un
                                                        nodo. Ejemplo: a{"->"}b, a{"->"}c, b-a la
                                                        centralidad más alta es para el nodo "a"
                                                        porque es el único nodo que actúa como
                                                        puente en el camino más corto entre b y c,
                                                        la centralidad para a(1), está a un nodo de
                                                        distancia de los restantes, mientras que
                                                        para b(0) y c(0), ya que no son camino de
                                                        ningún otro nodo
                                                    </p>
                                                }
                                            >
                                                <IconButton size="small">
                                                    <HelpIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </p>
                                    }
                                />
                            </Tabs>
                            {mapValueGraphTab[
                                graphSelectedMapResolution[actualGraphResolution].metric
                            ] === 0 && (
                                <StaticNetworkChart
                                    data={dataGraphResolution[actualGraphResolution]}
                                />
                            )}
                            {mapValueGraphTab[
                                graphSelectedMapResolution[actualGraphResolution].metric
                            ] === 1 && (
                                <StaticNetworkBetweennessChart
                                    data={dataGraphResolution[actualGraphResolution]}
                                />
                            )}
                        </>
                    )}

                    <Grid container px={10} py={4} gap={1} justifyContent={"center"}>
                        <Button
                            disabled={
                                Object.keys(dataGraphResolution[actualGraphResolution]).length === 0
                            }
                            variant="contained"
                            onClick={() => {
                                exportMultipleChartsToPdf(
                                    Object.entries(graphSelectedMapResolution)
                                        .filter(([key, value]) => value.selected)
                                        .map(([key, value]) => ({
                                            ...value.export,
                                            filterExclude: value.filterExclude,
                                            filterInclude: value.filterInclude,
                                            columns: value.columns,
                                            graph: key,
                                            comment: value.comment,
                                        })),
                                    datasetColumns || [],
                                    studentActivity,
                                    activity,
                                    actualResolution?.comment || "",
                                    actualResolution?.deliveryDate || ""
                                );
                            }}
                        >
                            Previsualizar
                        </Button>
                    </Grid>
                </Grid>
            </Grid>
            <QuestionAnswerForum
                studentActivity={studentActivity}
                updateData={getStudentActivity}
            />
            <br />
            <br />
            <br />
            <br />
        </div>
    );
};

export default TabResolution;
